import classnames from "classnames";
import "./style.scss";
import { PopoverIcon } from "./PopoverIcon";

export const PopOver = ({ className, children, style }) =>{
    const cn = classnames
    return <div style={style} className={cn("popover-container bg-gray-50 p-3 absolute bottom-14 left-10 z-10",className)}>
        {children}
        <span className="icon"><PopoverIcon /></span>
    </div>
}
